export default __webpack_public_path__ + "static/media/HandWrittenDigit.03b92c07.jpg";